import React, { useMemo, useState } from "react";
import Stack from "react-bootstrap/Stack";
import SearchBar from "../../../../dynamic-components/SearchBar";
import PayRecordModal from "../../../../utils/modals/shipment-tab/pay-record/PayRecordModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCirclePlus,
    faArrowRotateRight,
    faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";
// Components
import Message from "../../../../utils/modals/Message";
import { deleteShipmentSetData } from "../../../../../context/api/shipment/delete-shipment/deleteShipmentSetData";
import { deleteShipmentInvoicesSetData } from "../../../../../context/api/shipment/delete-shipment-invoices/delete-shipment/deleteShipmentInvoicesSetData";
import ConfirmModal from "../../../../dynamic-components/ConfirmModal";
import DataTable from "../../../../dynamic-components/DataTable";
import { expanded } from "../../../../dynamic-components/expanded";
import SideTable from "../../../../dynamic-components/SideTable";
// Context 
import { getLastFiveShippingSetData } from "../../../../../context/api/menu/shipment-menu/getLastFiveShipping/getLastFiveShippingSetData";


const ShipmentTable = ({
    lang,
    loader,
    btnLoader,
    getPdf,
    tableData,
    setShowAddModal,
    setShowEditModal,
    userData,
    setRefreshData,
    setMenuLoading,
    setMenuData
}) => {
    const translateFile = require(`../../../../../translate/${lang === "AR" ? "arabic" : "english"
        }/data.json`);
    const dataTranslate = translateFile.home_tabs.customerShipment_tab;
    const initialPayModal = {
        isShow: false,
        rowData: {},
    };

    const initialMessageRes = {
        success: Boolean,
        message: String,
        isShow: false,
    };

    const initialConfirmModal = {
        isShow: false,
        rowData: {},
    };

    const initialSuccessMessage = {
        success: false,
        type: "",
        data: {},
    };

    const action = {
        title: translateFile.popups.customerShipment_tab.delete_modal.title,
        submit: translateFile.popups.customerShipment_tab.delete_modal.submit,
    };

    const invoiceAction = {
        title: translateFile.popups.customerShipment_tab.delete_invoice.title,
        submit: translateFile.popups.customerShipment_tab.delete_invoice.submit,
    };

    const [cookies] = useCookies();
    const [messageResponse, setMessageResponse] = useState(initialMessageRes);
    const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
    const [confirmBtnLoader, setConfirmBtnLoader] = useState(false);
    const [confirmModal, setConfirmModal] = useState(initialConfirmModal);
    const [subConfirmModal, setSubConfirmModal] = useState(initialConfirmModal);
    const [showPayModal, setShowPayModal] = useState(initialPayModal);
    const sideTableHeaders = tableData
        ? Object.keys(tableData[0].recordDetails)
        : "";
    const searchByData = dataTranslate.table.table_head.search_by;
    const [search, setSearch] = useState({
        type: "filterId",
        value: "",
    });

    const handleSearch = (e) => {
        const value = e.target.value || undefined;
        setSearch((prev) => ({ ...prev, value: value }));
    };

    const searchOptions = [{ key: "id", value: searchByData.recordNumber }];

    const columns = useMemo(
        () => [
            {
                // Header: searchByData.recordNumber,
                // Header: "filterId",
                accessor: "filterId",
            },
            {
                Header: dataTranslate.table.table_body.recordDetails.title,
                accessor: "recordDetails",
                Cell: ({ cell }) => {
                    return (
                        <SideTable
                            data={dataTranslate}
                            cell={cell}
                            headers={sideTableHeaders}
                            side_table_name="recordDetails"
                        />
                    );
                },
            },
            {
                Header: dataTranslate.table.table_body.amount,
                accessor: "amountDollar",
            },
            {
                Header: dataTranslate.table.table_body.totalPaid,
                accessor: "totalPaid",
            },
            {
                Header: dataTranslate.table.table_body.totalRemaning,
                accessor: "totalRemaning",
            },
            {
                Header: dataTranslate.table.table_body.recordStatus,
                accessor: "recordStatus",
            },
            {
                Header: dataTranslate.table.table_body.notes,
                // accessor: "NB",
                Cell: ({ cell }) => {
                    return cell.row.original.NB ? (
                        <span>{cell.row.original.NB || translateFile.addotional.null}</span>
                    ) : (
                        <span>{translateFile.addotional.null}</span>
                    );
                },
            },
            {
                Header: dataTranslate.table.table_body.action,
                Cell: ({ cell }) => {
                    return (
                        <div className="d-flex flex-column gap-3 align-content-center justify-content-center">
                            <button
                                className="customerShipments_tab-table-table-body-btn"
                                onClick={async () => {
                                    // setMenuData([]);
                                    setShowEditModal((prev) => ({
                                        ...prev,
                                        isShow: true,
                                        action: "update",
                                        rowData: cell.row.original
                                    }))
                                    // await getLastFiveShippingSetData(lang, setMessageResponse, cookies, setMenuData, setMenuLoading, setShowAddModal);
                                }}
                            >
                                {dataTranslate.table.table_body.edit}
                            </button>
                            <button
                                className="customerShipments_tab-table-table-body-btn"
                                onClick={() =>
                                    setShowPayModal((prev) => ({
                                        ...prev,
                                        isShow: true,
                                        rowData: {
                                            id: cell.row.original.id,
                                            totalRemaning: cell.row.original.totalRemaning || 0,
                                            totalShipment: cell.row.original.totalShipment || 0,
                                        },
                                    }))
                                }
                            >
                                {dataTranslate.table.table_body.manuel_pay}
                            </button>

                            <button
                                className="customerShipments_tab-table-table-body-btn-delete"
                                onClick={() =>
                                    setConfirmModal((prev) => ({
                                        ...prev,
                                        isShow: true,
                                        rowData: cell.row.original,
                                    }))
                                }
                            >
                                {dataTranslate.table.table_body.delete}
                            </button>
                        </div>
                    );
                },
            },
            // expanded(),
        ],
        []
    );

    const subColumns = useMemo(
        () => [
            {
                Header: dataTranslate.table.table_body.sub_table.invoice_num,
                accessor: "id",
            },
            {
                Header: dataTranslate.table.table_body.sub_table.pay_date,
                // accessor: "creation_date",
                Cell: ({ cell }) => {
                    return <div>{cell.row.original.creation_date.split("T")[0]}</div>;
                },
            },
            {
                Header: dataTranslate.table.table_body.sub_table.invoice_type,
                accessor: "invoiceType",
            },
            {
                Header: dataTranslate.table.table_body.sub_table.invoice_amount,
                accessor: "invoiceAmountDollar",
            },
            {
                Header: dataTranslate.table.table_body.action,
                Cell: ({ cell }) => {
                    return (
                        <div className="d-flex flex-column gap-3 align-content-center justify-content-center">
                            <button
                                className="customerShipments_tab-table-table-body-btn-delete"
                                onClick={() =>
                                    setSubConfirmModal((prev) => ({
                                        ...prev,
                                        isShow: true,
                                        rowData: cell.row.original,
                                    }))
                                }
                            >
                                {dataTranslate.table.table_body.delete}
                            </button>
                        </div>
                    );
                },
            },
        ],
        []
    );

    const deleteShipment = async (id) => {
        const shipment_id = id;
        setConfirmBtnLoader(() => true);
        await deleteShipmentSetData(
            lang,
            setMessageResponse,
            cookies,
            shipment_id,
            setSuccessMessage
        );
        setConfirmBtnLoader(() => false);
    };

    const deleteInvoice = async (id) => {
        const invoiceId = id;
        setConfirmBtnLoader(() => true);
        await deleteShipmentInvoicesSetData(
            lang,
            setMessageResponse,
            cookies,
            invoiceId,
            setSuccessMessage
        );
        setConfirmBtnLoader(() => false);
    };
    // get menu list for the adding Modal
    const fetchMenuData = async () => {
        // setMenuData([]);
        setShowAddModal((prev) => ({
            ...prev,
            isShow: true,
            action: "add",
        }))
        // await getLastFiveShippingSetData(lang, setMessageResponse, cookies, setMenuData, setMenuLoading, setShowAddModal);
    }
    return (
        <>
            <Message
                messageResponse={messageResponse}
                close={() => setMessageResponse(initialMessageRes)}
                lang={lang}
            />

            <div className="customerShipments_tab-table w-100 d-flex flex-column align-items-center">
                <div className="customerShipments_tab-table-nav w-100 m-3 px-3">
                    <Stack direction="horizontal" gap={3}>
                        <div
                            className="customerShipments_tab-table-nav-btn"
                            onClick={() => {
                                fetchMenuData()
                            }}
                        >
                            <span>{dataTranslate.table.table_head.add}</span>
                            <FontAwesomeIcon
                                icon={faCirclePlus}
                                size="xl"
                                style={{ color: "#f2ce00" }}
                            />
                        </div>

                        <div className="customerShipments_tab-table-nav-btn" onClick={() => getPdf()}>
                            {btnLoader ? (
                                <Spinner animation="border" variant="warning" />
                            ) : (
                                <span>{dataTranslate.table.table_head.report}</span>
                            )}

                            <FontAwesomeIcon
                                icon={faFileContract}
                                size="xl"
                                style={{ color: "#f2ce00" }}
                            />
                        </div>

                        <div
                            className={
                                lang === "AR"
                                    ? "ms-auto customerShipments_tab-table-nav-btn"
                                    : "me-auto customerShipments_tab-table-nav-btn"
                            }
                            onClick={() => setRefreshData((prev) => prev + 1)}
                        >
                            <span>{dataTranslate.table.table_head.refresh}</span>
                            <FontAwesomeIcon
                                icon={faArrowRotateRight}
                                size="xl"
                                style={{ color: "#f2ce00" }}
                            />
                        </div>
                        <SearchBar
                            lang={lang}
                            search={search}
                            handleSearch={handleSearch}
                            options={searchOptions}
                            setSearch={setSearch}
                        />
                    </Stack>
                </div>

                <div className="customerShipments_tab-table-table w-100 m-3 px-3">
                    <PayRecordModal
                        show={showPayModal.isShow}
                        onHide={() => setShowPayModal(initialPayModal)}
                        lang={lang}
                        userData={userData}
                        data={showPayModal.rowData}
                        setRefreshData={setRefreshData}
                    />

                    <ConfirmModal
                        show={confirmModal.isShow}
                        onHide={() => setConfirmModal(initialConfirmModal)}
                        post={deleteShipment}
                        data={confirmModal.rowData}
                        lang={lang}
                        dataTranslate={translateFile}
                        setRefreshData={setRefreshData}
                        action={action}
                        btnLoader={confirmBtnLoader}
                        successMessage={successMessage}
                        setSuccessMessage={setSuccessMessage}
                    />

                    <ConfirmModal
                        show={subConfirmModal.isShow}
                        onHide={() => setSubConfirmModal(initialConfirmModal)}
                        post={deleteInvoice}
                        data={subConfirmModal.rowData}
                        lang={lang}
                        dataTranslate={translateFile}
                        setRefreshData={setRefreshData}
                        action={invoiceAction}
                        btnLoader={confirmBtnLoader}
                        successMessage={successMessage}
                        setSuccessMessage={setSuccessMessage}
                    />

                    {tableData ? (
                        <DataTable
                            lang={lang}
                            columns={columns}
                            // subColumns={subColumns}
                            dataTable={tableData}
                            loader={loader}
                            pageClass="customerShipments_tab"
                            subDataKey="invoices"
                            search={search}
                        />
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </>
    );
}

export default ShipmentTable;